import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    message: sessionStorage.getItem('navIndex')
}
const mutations = {
    updateMessage(state, payload) {
      state.message = payload;
      sessionStorage.setItem('navIndex',payload)
    }
  }

export default new Vuex.Store({
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js